var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<fieldset ng-class=\"{'has-error':fc[0].$invalid && (fc[0].$touched || form.$submitted )}\">\n<legend ng-if=\"to.label\">\n{{to.label}}\n<span ng-if=\"options.data.modello.validations.nullable===false || options.data.modello.validations.required\">*</span>\n</legend>\n<formly-transclude></formly-transclude>\n</fieldset>";
var id1="bsslegend.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;